import { render, staticRenderFns } from "./SuitupFooter.vue?vue&type=template&id=06f17af5"
import script from "./SuitupFooter.vue?vue&type=script&lang=js"
export * from "./SuitupFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports